import React from 'react';
import classnames from 'classnames';
import IconConcierge from '@spothero/icons/user-pin';
import IconPublicTransit from '@spothero/icons/train-filled';
import IconCar from '@spothero/icons/car';
import SpotImages from 'common/spot-details/spot-images';
import SpotUtils from 'utils/spot';
import { CarouselVariant } from 'common/image-carousel';
export const ShuttleInformation = ({ shuttle, facilityTitle, iataCode, }) => {
    const { type, duration, fast_frequency: fastFrequency, slow_frequency: slowFrequency, hours: accessHours, images, } = shuttle;
    const accessHoursFormatted = accessHours?.periods?.length
        ? SpotUtils.formatAccessHours(accessHours)
        : null;
    const frequencySpan = fastFrequency && slowFrequency
        ? `${fastFrequency} - ${slowFrequency}`
        : fastFrequency || slowFrequency || '';
    const shuttleDetailsClasses = classnames('ShuttleInformation-details', {
        'no-images': !images.length,
    });
    let subtitle = 'Shuttle Information';
    if (type === 'curbside-valet') {
        subtitle = 'Curbside Dropoff';
    }
    else if (type === 'public-transit') {
        subtitle = 'Accessible via Public Transit';
    }
    return (<div className="ShuttleInformation">
            <h4 className="subtitle">{subtitle}</h4>
            {type === 'taxi' && (<span className="ShuttleInformation-no-shuttle">
                    <IconCar />
                    No shuttle available.
                </span>)}
            {type === 'public-transit' && (<span className="ShuttleInformation-no-shuttle">
                    <IconPublicTransit />
                    No shuttle available, public transit on site.
                </span>)}
            {type === 'curbside-valet' && (<span className="ShuttleInformation-no-shuttle">
                    <IconConcierge />
                    Concierge service curbside dropoff.
                </span>)}
            {(type === 'scheduled' || type === 'on-demand') && (<div className="ShuttleInformation-container">
                    <dl className={shuttleDetailsClasses}>
                        {type === 'scheduled' && (<div>
                                <dt className="ShuttleInformation-details-key">
                                    Frequency
                                </dt>
                                <dd className="ShuttleInformation-details-value">
                                    {frequencySpan &&
                    `Every ${frequencySpan} mins`}
                                </dd>
                            </div>)}
                        <div>
                            <dt className="ShuttleInformation-details-key">
                                Duration to {iataCode}
                            </dt>
                            <dd className="ShuttleInformation-details-value">
                                {duration} mins
                            </dd>
                        </div>
                        <div>
                            <dt className="ShuttleInformation-details-key">
                                Shuttle Hours
                            </dt>
                            <dd className="ShuttleInformation-details-value">
                                {accessHours.text &&
                accessHours.text.length === 1 &&
                'Operates 24/7'}
                                {accessHoursFormatted &&
                accessHoursFormatted.map((period, i) => {
                    return (<p className="hours-of-operation-period" key={i}>
                                                <span className="day">
                                                    {period.days}
                                                </span>
                                                , <span>{period.value}</span>
                                                <br />
                                            </p>);
                })}
                            </dd>
                        </div>
                        {type === 'on-demand' && (<div style={{ visibility: 'hidden', width: '59px' }}/>)}
                    </dl>
                    {Boolean(images.length) && (<div className="ShuttleInformation-carousel-container">
                            <SpotImages images={images} alt={`${facilityTitle} shuttle images`} carouselVariant={CarouselVariant.SINGLE}/>
                        </div>)}
                </div>)}
        </div>);
};
export default ShuttleInformation;
